import { h } from 'preact';

const ProductBadge = ({ badges, className, containerClassName, text }) => {
  const badge = window.getProductBadge(badges);

  if (!badge && !text) {
    return null;
  }

  return (
    <div className={containerClassName || 'absolute z-20 left-0 bottom-16'}>
      <div
        className={className || 'py-2 ml:py-4 px-8 body-6 !font-normal ml:uppercase'}
        style={{ background: window.TMW.badgeColor }}
        dangerouslySetInnerHTML={{
          __html: text || badge,
        }}
      >
      </div>
    </div>
  );
};

export default ProductBadge;
